// extracted by mini-css-extract-plugin
module.exports = {"splashcontainer":"index-module--splashcontainer--3_Gia","painting":"index-module--painting--3KvoN"};